import { useObjectState } from 'common/Hooks/UseObjectState'
import { mapManagers } from 'common/Utils/ManagersUtils'
import { getPostponedPaymentMethodsKeyValuePair } from 'common/Utils/PaymentMethodUtils'
import Modal from 'components/Common/Modal/Modal'
import { OptionsInput } from 'components/Common/OptionsInput'
import { InputMinMaxNumbers } from 'components/InputMinMaxNumbers'
import CountryFlag from 'pages/CRMUserDetail/ComponenteTablas/CountryFlag'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { getManagers } from 'store/actions'

const INIT_STATE = {
	availableCountries: [],
	availablePaymentMethods: [],
	availableManagers: [],
	amountEuroRange: null,
	logisticsCostEuroRange: null,
	productionCostEuroRange: null,
	marginEuroRange: null,
}

export const BillingFiltersModal = ({ t, setFilters, managers, getManagers }) => {

	// Modal open/closed state:
	const [isModalOpen, setIsModalOpen] = useState(false)

	// Filter inputs state:
	const { objectData, handleOnChange, resetState } = useObjectState(INIT_STATE)

	// Fetch managers for the Manager select filter if we don't already have them:
	useEffect(() => {
		if (managers == null || managers.length === 0) getManagers()
	}, [managers])

	// Return React Element:
	return (
		<div>

			{/* Button to open the modal: */}
			<button
				className='btn btn-secondary'
				onClick={() => { setIsModalOpen(true) }}>
				{t('filter', { ns: 'naming' })}
			</button>

			{/* Modal: */}
			<Modal
				isOpen={isModalOpen}
				closeModal={() => { setIsModalOpen(false) }}

				// Modal Title:
				title={t('filterBilling', { ns: 'naming' })}

				// Modal Content:
				body={
					<div className='m-4'>

						{/* Countries multi-select: */}
						<div className='my-1'>
							<span className='ms-2'>{t('countries', { ns: 'naming' })}</span>
							<CountryFlag
								isEditable
								onChange={(e) => handleOnChange('availableCountries', e.map(country => country.value))}
								isMulti
								automaticMappedValue
								countryState={objectData.availableCountries}
							/>
						</div>

						{/* Payment Methods multi-select: */}
						<OptionsInput
							isMulti
							value={objectData.availablePaymentMethods}
							setValue={handleOnChange}
							objectElement='availablePaymentMethods'
							title={t('paymentMethod', { ns: 'naming' })}
							options={getPostponedPaymentMethodsKeyValuePair(t)}
							automaticMappedValue
						/>

						{/* Managers multi-select: */}
						<OptionsInput
							isMulti
							value={objectData.availableManagers}
							setValue={handleOnChange}
							objectElement='availableManagers'
							title={t('managers', { ns: 'naming' })}
							options={mapManagers(managers)}
							automaticMappedValue
						/>

						{/* Min-Max range for Total Price (Importe): */}
						<InputMinMaxNumbers
							t={t}
							name={t('totalPrice', { ns: 'naming' })}
							range={objectData.amountEuroRange}
							setRange={(range) => handleOnChange('amountEuroRange', range)}
						/>

						{/* Min-Max range for Logistics Cost (Logística): */}
						<InputMinMaxNumbers
							t={t}
							name={t('logistics', { ns: 'naming' })}
							range={objectData.logisticsCostEuroRange}
							setRange={(range) => handleOnChange('logisticsCostEuroRange', range)}
						/>

						{/* Min-Max range for Production Cost (Producción): */}
						<InputMinMaxNumbers
							t={t}
							name={t('production', { ns: 'naming' })}
							range={objectData.productionCostEuroRange}
							setRange={(range) => handleOnChange('productionCostEuroRange', range)}
						/>

						{/* Min-Max range for Margin (Margen): */}
						<InputMinMaxNumbers
							t={t}
							name={t('margin_value', { ns: 'naming' })}
							range={objectData.marginEuroRange}
							setRange={(range) => handleOnChange('marginEuroRange', range)}
						/>
					</div>
				}

				// Bottom-right buttons:
				buttons={[
					// ("Close" button is included in the Modal component)

					// "Reset" button to set everything to null:
					<button
						onClick={() => {
							resetState()
							setFilters(INIT_STATE)
							setIsModalOpen(false)
						}}
						key='reset_billing_filters'
						className='btn btn-primary'>
						{t('reset', { ns: 'naming' })}
					</button>,

					// "Apply" button to apply the filters, close the modal, and search:
					<button
						onClick={() => {
							setFilters(objectData)
							setIsModalOpen(false)
						}}
						key='apply_billing_filters'
						className='btn btn-primary'>
						{t('apply', { ns: 'naming' })}
					</button>,
				]}
			/>
		</div>
	)
}

BillingFiltersModal.propTypes = {
	t: PropTypes.func,
	setFilters: PropTypes.func,
	managers: PropTypes.array,
	getManagers: PropTypes.func,
}

const mapStateToProps = (state) => ({
	managers: state.Users.managers,
})

const mapDispatchToProps = { getManagers }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BillingFiltersModal))
